function splitMarkdownTableRow(line) {
  const source = String(line || "").trim().replace(/^\|/, "").replace(/\|$/, "");
  const cells = [];
  let cell = "";
  let escaped = false;
  for (const character of source) {
    if (character === "|" && !escaped) {
      cells.push(cell.trim());
      cell = "";
    } else {
      cell += character;
    }
    escaped = character === "\\" && !escaped;
    if (character !== "\\") escaped = false;
  }
  cells.push(cell.trim());
  return cells;
}

export function stripSearchQueriesFromUnderwritingMarkdown(reportMarkdown) {
  const lines = String(reportMarkdown || "").replace(/\r\n?/g, "\n").split("\n");
  const output = [];
  for (let index = 0; index < lines.length;) {
    if (/^\s*\|/.test(lines[index]) && /^\s*\|?\s*:?-{3,}/.test(lines[index + 1] || "")) {
      const table = [];
      while (index < lines.length && /^\s*\|/.test(lines[index])) table.push(lines[index++]);
      const headers = splitMarkdownTableRow(table[0]);
      const hidden = headers
        .map((header, cellIndex) => (/\b(?:search(?:es|ed)?|quer(?:y|ies))\b/i.test(header.replace(/[*_`]/g, "")) ? cellIndex : -1))
        .filter((cellIndex) => cellIndex >= 0);
      if (!hidden.length) {
        output.push(...table);
        continue;
      }
      table.forEach((row) => {
        const cells = splitMarkdownTableRow(row).filter((_, cellIndex) => !hidden.includes(cellIndex));
        output.push(`| ${cells.join(" | ")} |`);
      });
      continue;
    }
    if (/^\s*(?:[-*]\s*)?(?:search(?:es)?(?:\s*\/\s*quer(?:y|ies))?|quer(?:y|ies)|exact search string)\s*:/i.test(lines[index])) {
      index += 1;
      continue;
    }
    output.push(lines[index++]);
  }
  return output.join("\n").replace(/\n{3,}/g, "\n\n").trim();
}
